module.exports = "//d274d294w9cx2v.cloudfront.net/e9795e43393ccda1cae248ebcf6bc65c44423b27/images/photo-couple.png";